/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { parse, stringify } from 'zipson';
import { Names } from './storeName';

// ppt与大纲交互状态管理
export const useStore = defineStore(Names.MAIN, {
  state: () => ({
    activeIndex: 0, // 当前选中ppt索引
    activeNodeId: null, // 当前选中大纲节点id
    activeSlideId: null, // 当前预览幻灯片id
    activeTemplateId: null, // 当前选中模板id
  }),
  persist: {
    key: 'ai-ppt-store_active',
    storage: sessionStorage,
    paths: [
      'activeSlideId',
    ],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },

  getters: {
    getActiveIndex: (state) => state.activeIndex,
    getActiveNodeId: (state) => state.activeNodeId,
    getActiveSlideId: (state) => state.activeSlideId,
    getActiveTemplateId: (state) => state.activeTemplateId,
  },

  actions: {
    changeActiveIndex(index) {
      this.activeIndex = index;
    },
    changeActiveNodeId(index) {
      this.activeNodeId = index;
    },
    changeActiveSlideId(index) {
      this.activeSlideId = index;
    },
    changeActiveTemplateId(index) {
      this.activeTemplateId = index;
    },
  },
})
